import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AUTH_SERVICE } from '@core-features/core';
import { CopilotChatInput } from '@copilotkit/angular';

/** Chat composer, with a sign-in prompt above it for anonymous visitors. */
@Component({
  selector: 'pc-chat-input',
  imports: [CopilotChatInput],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (!$isAuthenticated()) {
      <p class="pc-signin">
        Sign in to unlock more chat tools and personalized answers
      </p>
    }
    <copilot-chat-input />
  `,
  styles: `
    :host {
      display: block;
    }

    .pc-signin {
      margin: 0 0 calc(0.5 * var(--ds-spacing));
      padding: calc(0.5 * var(--ds-spacing)) calc(0.8 * var(--ds-spacing));
      border: 1px solid var(--ds-warning-100);
      border-radius: calc(0.6 * var(--ds-spacing));
      background: var(--ds-warning-50);
      color: var(--ds-neutral-900);
      font-size: 13px;
      line-height: 1.4;
    }
  `,
})
export class PalchatChatInputComponent {
  private readonly _authService = inject(AUTH_SERVICE);

  protected readonly $isAuthenticated = this._authService.$isAuthenticated;
}
